import { Link } from "react-router-dom";
import "./admin.css";
const Dashboard = () => {
  return (
    <div className="hobdash-container">
      {/* Welcome */}
      <div className="hobdash-welcome-card">
        <h2 className="hobdash-welcome-title">Welcome back, Admin</h2>

        <p className="hobdash-welcome-text">Manage your HOB content.</p>
      </div>
    </div>
  );
};

export default Dashboard;
